import { Button } from '@ctw/shared/components/button';
import { ContentTypeIcon } from '@ctw/shared/components/icons/content-type-icon';
import { Tooltip } from '@ctw/shared/components/tooltip';
import { useResourceModal } from '@ctw/shared/context/resource-modal-context';
import { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import { tw } from '@ctw/shared/utils/tailwind';

export interface ViewSourceDocumentButtonProps {
  resourceType: 'Binary' | 'DocumentReference';
  resourceId: string;
  contentType: string | undefined;
  enabled: boolean;
}

// Opens the given resource in the full-screen resource modal. Shared by every source document
// row across the Encounter and EpisodeOfCare drawers, whether it resolves by Binary id or by
// DocumentReference id directly.
export const ViewSourceDocumentButton = ({
  resourceType,
  resourceId,
  contentType,
  enabled,
}: ViewSourceDocumentButtonProps) => {
  const telemetry = useTelemetry();
  const { openResourceModal } = useResourceModal({
    layout: {
      mode: 'full',
      overflowBehavior: 'hidden',
      fullbleed: true,
      showCloseButton: false,
    },
  });

  return (
    <Tooltip
      id="related-document-tooltip"
      content="View source document"
      place="top"
      enabled={enabled}
    >
      <Button
        type="button"
        variant="unstyled"
        className={tw`flex shrink-0 items-center justify-center px-4 text-primary-text hover:opacity-80`}
        ariaLabel="View source document"
        disabled={!enabled}
        telemetryContext={{ resourceType, resourceId }}
        onClick={() => openResourceModal({ telemetry, resourceType, resourceId })}
      >
        <ContentTypeIcon contentType={contentType ?? ''} className={tw`h-5 w-5`} />
      </Button>
    </Tooltip>
  );
};
